const getFontSizeFromExcelFontValue = (ptFontSize: number) => {
  if (ptFontSize <= 8) {
    return 'var(--font-size-xxs)';
  }
  if (ptFontSize >= 21) {
    return 'var(--font-size-regular)';
  }
  if (ptFontSize >= 11) {
    return 'var(--font-size-s)';
  }
  return 'var(--font-size-xs)';
};

export const replaceFontSizesWithJunctionValues = (data: string): string => {
  const regex = /font-size:([1-9][0-9]*)pt/g;
  const regexFontSizesRow = RegExp(regex);
  let ptValues: RegExpExecArray | null = null;
  const values: number[] = [];

  // eslint-disable-next-line
  while ((ptValues = regexFontSizesRow.exec(data))) {
    values.push(parseInt(ptValues[1], 10));
  }

  values.forEach((ptValue) => {
    if (!ptValue) return;
    data = data.replaceAll(
      `font-size:${ptValue}pt`,
      `font-size:${getFontSizeFromExcelFontValue(ptValue)}`
    );
  });
  return data;
};
